import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const formatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
})

const FasterPaymentAddon = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          salaryAdvance {
            addons {
              fasterPayment
            }
          }
        }
      }
    }
  `)

  return <span>{formatter.format(data.site.siteMetadata.salaryAdvance.addons.fasterPayment)}</span>
}

export default FasterPaymentAddon
